import { render, staticRenderFns } from "./ReportList.vue?vue&type=template&id=30707f20&scoped=true"
import script from "./ReportList.vue?vue&type=script&lang=js"
export * from "./ReportList.vue?vue&type=script&lang=js"
import style0 from "./ReportList.vue?vue&type=style&index=0&id=30707f20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30707f20",
  null
  
)

export default component.exports